import { Pipe, PipeTransform } from '@angular/core'
import { EstimateBalancePaymentStatus } from '@mmx/shared'

const KEY_BY_STATUS: Record<EstimateBalancePaymentStatus, string> = {
  [EstimateBalancePaymentStatus.UNPAID]: 'balance.payment-status.unpaid',
  [EstimateBalancePaymentStatus.PARTIAL]: 'balance.payment-status.partial',
  [EstimateBalancePaymentStatus.PAID]: 'balance.payment-status.paid',
  [EstimateBalancePaymentStatus.OVERPAID]: 'balance.payment-status.overpaid',
  [EstimateBalancePaymentStatus.REFUNDED]: 'balance.payment-status.refunded',
}

@Pipe({
  name: 'balancePaymentStatus',
  standalone: true,
})
export class BalancePaymentStatusPipe implements PipeTransform {
  transform(value: EstimateBalancePaymentStatus | null | undefined): string {
    if (value == null) {
      return 'balance.payment-status.unknown'
    }
    return KEY_BY_STATUS[value] ?? 'balance.payment-status.unknown'
  }
}
